export class AddressDetailModel {
  address!: string;
  road!: string;
  building!: string;
  soi!: string;
  floorNo!: string;
  roomNo!: string;
  homeNo!: string;
  homeGroup!: string;
  district!: string;
  subDistrict!: string;
  postCode!: string;
  province!: string;
  country!: string;
}

export class MerchantAddressModel extends AddressDetailModel {
  id!: number;
  name!: string;
  addressInfoType!: number;
  addressName!: string;
  language!: string;
}
